import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=715ef11e&scoped=true&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"
import style0 from "./Child.vue?vue&type=style&index=0&id=715ef11e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ef11e",
  null
  
)

export default component.exports